'use client';

import React, { useEffect, useState } from 'react';

import { Rank1stIcon, Rank2stIcon, Rank3stIcon } from '@/assets';
import type { UserTopLeaderboard } from '@/types/leaderboard';

import TopUser from './TopUser';

interface LeaderBoardProps {
  aigData: UserTopLeaderboard[];
  creatorData: UserTopLeaderboard[];
}

export enum TabKey {
  aig = 'aig',
  artwork = 'mint',
  prompt = 'prompt',
  assetLike = 'top-like',
  topCredit = 'top-credit',
  topCreator = 'top-creator',
}
const TABS = [
  {
    key: TabKey.topCreator,
    text: 'Top Creator',
  },
  // {
  //   key: TabKey.aig,
  //   text: 'Top AIG',
  // },
];

export const rankIcons = [<Rank1stIcon />, <Rank2stIcon />, <Rank3stIcon />];
export const rankText = ['1st ranked', '2nd ranked', '3rd ranked'];

const LeaderBoard: React.FC<LeaderBoardProps> = ({ aigData, creatorData }) => {
  const [activeTab, setActiveTab] = useState(TabKey.topCreator);
  const [data, setData] = useState<UserTopLeaderboard[]>(creatorData);

  useEffect(() => {
    if (activeTab === TabKey.aig) {
      setData(aigData);
    } else {
      setData(creatorData);
    }
  }, [activeTab]);

  return (
    <div
      style={{
        backgroundImage: `url('/images/bg-leaderboard-2.jpg')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
      }}
      className="relative h-[calc(100vh-62px)] w-full overflow-hidden xl:h-[calc(100vh-72px)]"
    >
      <div className="main-container relative max-w-[70%]">
        <div
          aria-expanded={activeTab !== TabKey.aig}
          className="mb-4 mt-10 flex items-center justify-between gap-2 xl:my-[20px] lg:flex-col aria-expanded:sm:!mb-[30px]"
        >
          <div className="bg-gradient-to-r  from-[#E34E2D] to-[#F56C4E] bg-clip-text text-20 font-semibold text-transparent">
            Leaderboard
          </div>
          <div className="flex max-w-[600px] items-center justify-center rounded-full bg-gray-50 p-2 sm:w-full">
            {TABS.map((item, index) => (
              <p
                aria-expanded={item.key === activeTab}
                key={index}
                className={`w-[200px] cursor-pointer rounded-full bg-transparent p-[10px] text-center text-14 font-semibold text-gray-500 duration-300 aria-expanded:bg-white aria-expanded:text-black sm:w-[calc(100%/2)] sm:!text-[12px] ${
                  item.key !== TabKey.aig && 'flex items-center justify-center'
                } `}
                onClick={() => setActiveTab(item.key)}
              >
                {item.text}
              </p>
            ))}
          </div>
        </div>
        <TopUser activeTab={activeTab} listAll={data} />
      </div>
    </div>
  );
};

export default LeaderBoard;
